(function () {
  var WIDGET_ID = '145363';
  var MOBILE_MQ = '(max-width: 749px)';
  var PEEK_WIDTH = '78%';
  var PEEK_GAP = '0';

  function getWidget() {
    if (!window.Rebuy || !Array.isArray(window.Rebuy.widgets)) return null;
    return window.Rebuy.widgets.find(function (w) {
      return String(w.id) === WIDGET_ID;
    });
  }

  function getRoot(widget) {
    return (
      document.querySelector('#rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.splide') ||
      (widget && widget.element && widget.element.querySelector('.rebuy-product-grid.splide'))
    );
  }

  function getSplide(widget) {
    return widget && widget.View && widget.View.carousel ? widget.View.carousel : null;
  }

  function clearInlineWidths(root) {
    if (!root) return;
    root.querySelectorAll('.splide__slide').forEach(function (slide) {
      slide.style.removeProperty('width');
    });
  }

  function storeOriginal(splide) {
    if (splide.__ymalOriginalOptions) return;
    splide.__ymalOriginalOptions = {
      perPage: splide.options.perPage,
      perMove: splide.options.perMove,
      gap: splide.options.gap,
      padding: splide.options.padding,
      fixedWidth: splide.options.fixedWidth,
      focus: splide.options.focus,
      trimSpace: splide.options.trimSpace
    };
  }

  function applyMobilePeek(splide, root) {
    storeOriginal(splide);

    root.classList.add('is-ymal-peek');
    root.classList.remove('small-columns-2');
    if (!root.classList.contains('small-columns-1')) {
      root.classList.add('small-columns-1');
    }

    Object.assign(splide.options, {
      fixedWidth: PEEK_WIDTH,
      perPage: 1,
      perMove: 1,
      gap: PEEK_GAP,
      padding: 0,
      focus: 0,
      trimSpace: false,
      drag: true,
      arrows: true,
      pagination: true
    });

    clearInlineWidths(root);
    splide.refresh();
    clearInlineWidths(root);

    if (splide.Components && splide.Components.Layout && typeof splide.Components.Layout.resize === 'function') {
      try {
        splide.Components.Layout.resize(true);
      } catch (err) {
        /* ignore */
      }
    }
  }

  function applyDesktop(splide, root) {
    root.classList.remove('is-ymal-peek');
    root.classList.remove('small-columns-1');
    if (!root.classList.contains('small-columns-2')) {
      root.classList.add('small-columns-2');
    }

    var original = splide.__ymalOriginalOptions || {};
    Object.assign(splide.options, {
      fixedWidth: original.fixedWidth || undefined,
      perPage: original.perPage != null ? original.perPage : 2,
      perMove: original.perMove,
      gap: original.gap || 0,
      padding: original.padding || 0,
      focus: original.focus,
      trimSpace: original.trimSpace
    });

    if (!splide.options.fixedWidth) {
      delete splide.options.fixedWidth;
    }

    clearInlineWidths(root);
    splide.refresh();
  }

  function sync() {
    var widget = getWidget();
    if (!widget) return false;
    var splide = getSplide(widget);
    var root = getRoot(widget);
    if (!splide || !root || !splide.root) return false;

    if (window.matchMedia(MOBILE_MQ).matches) {
      applyMobilePeek(splide, root);
    } else if (root.classList.contains('is-ymal-peek')) {
      applyDesktop(splide, root);
    }

    return true;
  }

  function watchWidths(root) {
    if (!root || root.dataset.ymalWidthWatch === 'true') return;
    root.dataset.ymalWidthWatch = 'true';

    var observer = new MutationObserver(function () {
      if (!root.classList.contains('is-ymal-peek')) return;
      var dirty = false;
      root.querySelectorAll('.splide__slide').forEach(function (slide) {
        if (slide.style.width && slide.style.width.indexOf('50%') !== -1) {
          slide.style.removeProperty('width');
          dirty = true;
        }
      });
      if (dirty) {
        var widget = getWidget();
        var splide = getSplide(widget);
        if (splide && splide.Components && splide.Components.Layout) {
          try {
            splide.Components.Layout.resize(true);
          } catch (err) {
            /* ignore */
          }
        }
      }
    });

    observer.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: ['style', 'class']
    });
  }

  function init() {
    if (!sync()) return;
    var widget = getWidget();
    var root = getRoot(widget);
    watchWidths(root);
  }

  var tries = 0;
  function boot() {
    tries += 1;
    if (sync()) {
      var widget = getWidget();
      watchWidths(getRoot(widget));
      return;
    }
    if (tries < 40) {
      window.setTimeout(boot, 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('rebuy:smartcart.ready', init);
  window.addEventListener('resize', function () {
    window.clearTimeout(window.__rebuyYmalPeekResize);
    window.__rebuyYmalPeekResize = window.setTimeout(init, 150);
  });

  var domObserver = new MutationObserver(function () {
    var root = document.querySelector('#rebuy-widget-' + WIDGET_ID + ' .rebuy-product-grid.splide');
    if (root && !root.classList.contains('is-ymal-peek') && window.matchMedia(MOBILE_MQ).matches) {
      init();
    }
  });
  domObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
